module.exports = __webpack_public_path__ + "img/polis-colored-logo.4320894f.svg";